import React from "react";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { waiverSchema } from "./WaiverSchema";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { themeService } from "../../../../theme/service/activeTheme.service";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";

export const WaiverReports = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ViewReport data={{}} />;
  }
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  // let removeDuplicated = ReportGroupingUtils.RemoveDuplicateTestCodesFromGroupedReport(reportsByDateAndUser);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportsByDateAndUser);

  return decodedReports.map((report, i) => {
    return <ViewReport key={i} data={report} {...props} />;
  });
};

const ViewReport = (props) => {
  const { data } = props;

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      {data.decodedData.map((e, i) => (
        <div key={i}>
          <ReportTitleSection title={"Waiver Type Report"} fontSizeOverride={"35px"} />
          <ReportFraInfoSectionContainer {...props} />
          <span className="spacer"></span>
          <table className="table-bordered">
            {waiverSchema.map((ele, k) => (
              <ReportTableSectionRenderer section={ele} rowsData={e.summary} key={k} />
            ))}
          </table>
        </div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/WaiverReport/WaiverReport.jsx